import * as React from 'react';

const Larghezza = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M18 7.63699L22.363 12L18 16.363L16.586 14.949L18.534 13H5.50699L7.45699 14.95L6.04299 16.364L1.67899 12L6.04299 7.63699L7.45699 9.04999L5.50699 11H18.534L16.586 9.04999L18 7.63699Z" fill="currentColor"/>
  </svg>
);

export default Larghezza;
